export var ExpandButtonStyle;
(function (ExpandButtonStyle) {
    ExpandButtonStyle["ARROW"] = "arrow";
})(ExpandButtonStyle || (ExpandButtonStyle = {}));
export var ExpandButtonPosition;
(function (ExpandButtonPosition) {
    ExpandButtonPosition["END"] = "end";
    ExpandButtonPosition["START"] = "start";
})(ExpandButtonPosition || (ExpandButtonPosition = {}));
